import { router } from 'expo-router';

import type { Command } from './types';

export const newTaskCommand: Command = {
	id: 'new-task',
	title: 'New Task',
	description: 'Create a new task',
	icon: 'checkmark-circle',
	category: 'create',
	keywords: ['task'],
	action: (closeSearch) => {
		router.push('/tasks/new');
		closeSearch?.();
	},
};
